var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgTranslationBlue = function SvgTranslationBlue(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#2563EB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.667,
    clipPath: "url(#translation-blue_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m4.166 6.666 5 5M3.334 11.666l5-5 1.667-2.5M1.666 4.166h10M5.834 1.666h.833M18.333 18.333 14.167 10 10 18.333M11.666 15h5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "translation-blue_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTranslationBlue);
export default ForwardRef;